export const validateHousebookSchema = json => {
    return true;
};
